
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skimap",
      function () {
        return require("private-next-pages/[region]/[resort]/skimap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skimap"])
      });
    }
  